import React from 'react';
import { any, oneOf, oneOfType, array, object } from 'prop-types';

import './Skeleton.scss';
import bem from '../../utils/bem';

const BLOCK = 'skeleton';

export const Bone = ({ type, modifiers }) => (
  <div className={bem(`${BLOCK}__${type}`, modifiers)} />
);

Bone.propTypes = {
  modifiers: oneOfType([array, object]),
  type: oneOf([
    'heading',
    'text',
    'paragraph',
    'username-tag',
    'box',
    'username',
  ]),
};

export const Skeleton = ({ children }) => (
  <div className={BLOCK} role="presentation">
    {children}
  </div>
);

Skeleton.propTypes = {
  children: any,
};

export default Skeleton;
